import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "facebook",
  "use": "facebook-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"facebook\"><path d=\"M16.85 9.73h3.74l-.44 4.14h-3.3v12h-4.97v-12H9.41V9.73h2.47V7.24c0-1.76.42-3.1 1.25-4 .84-.91 2.21-1.37 4.12-1.37h3.3v4.14H18.5c-.38 0-.68.03-.92.1a.8.8 0 0 0-.49.33c-.1.17-.16.34-.19.51-.03.17-.04.4-.04.72v2.06Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol